/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/eva-message/eva-message.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import10 from '@ngx-translate/core/src/translate.pipe';
import * as import11 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import12 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '@ngx-translate/core/src/translate.service';
import * as import15 from '@angular/common/src/directives/ng_class';
export class Wrapper_EvaMessageComponent {
  /*private*/ _eventHandler:Function;
  context:import0.EvaMessageComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  constructor() {
    this._changed = false;
    this.context = new import0.EvaMessageComponent();
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_message(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.message = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_EvaMessageComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_EvaMessageComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.EvaMessageComponent>;
  _EvaMessageComponent_0_3:Wrapper_EvaMessageComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_EvaMessageComponent_Host0,renderType_EvaMessageComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'eva-message',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_EvaMessageComponent0(this.viewUtils,this,0,this._el_0);
    this._EvaMessageComponent_0_3 = new Wrapper_EvaMessageComponent();
    this.compView_0.create(this._EvaMessageComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._EvaMessageComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.EvaMessageComponent) && (0 === requestNodeIndex))) { return this._EvaMessageComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._EvaMessageComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const EvaMessageComponentNgFactory:import8.ComponentFactory<import0.EvaMessageComponent> = new import8.ComponentFactory<import0.EvaMessageComponent>('eva-message',View_EvaMessageComponent_Host0,import0.EvaMessageComponent);
const styles_EvaMessageComponent:any[] = ([] as any[]);
var renderType_EvaMessageComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_EvaMessageComponent,{});
export class View_EvaMessageComponent0 extends import2.AppView<import0.EvaMessageComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _NgClass_3_3:import9.Wrapper_NgClass;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_18:any;
  _map_19:any;
  /*private*/ _expr_20:any;
  _pipe_translate_0:import10.TranslatePipe;
  /*private*/ _expr_22:any;
  _pipe_translate_1:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_EvaMessageComponent0,renderType_EvaMessageComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_18 = import1.UNINITIALIZED;
    this._map_19 = import3.pureProxy4((p0:any,p1:any,p2:any,p3:any):{[key: string]:any} => {
      return {
        'eva-3-icon-warning': p0,
        'eva-3-icon-info-circle': p1,
        'eva-3-icon-smile-circle': p2,
        'eva-3-icon-error-circle': p3
      }
      ;
    });
    this._expr_20 = import1.UNINITIALIZED;
    this._expr_22 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','message-icon-container'),(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','message-icon'),(null as any));
    this._NgClass_3_3 = new import9.Wrapper_NgClass(this.parentView.injectorGet(import11.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import12.KeyValueDiffers,this.parentIndex),new import13.ElementRef(this._el_3),this.renderer);
    this._text_4 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','message-header'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'h5',new import3.InlineArray2(2,'class','message-title eva-3-h5'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_5,'\n    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','message-body'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'p',new import3.InlineArray2(2,'class','message-text eva-3-p'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_11,'\n    ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import10.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.NgClass) && (3 === requestNodeIndex))) { return this._NgClass_3_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_3_0_0:any = 'message-icon';
    this._NgClass_3_3.check_klass(currVal_3_0_0,throwOnChange,false);
    const currVal_3_0_1:any = this._map_19((this.context.message.icon == 'warning'),(this.context.message.icon == 'info'),(this.context.message.icon == 'success'),(this.context.message.icon == 'error'));
    this._NgClass_3_3.check_ngClass(currVal_3_0_1,throwOnChange,false);
    this._NgClass_3_3.ngDoCheck(this,this._el_3,throwOnChange);
    const currVal_18:any = import3.inlineInterpolate(1,'eva-3-message ',this.context.message.type,'');
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_0,'className',currVal_18);
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_20:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.message.title)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_20,currVal_20))) {
      this.renderer.setText(this._text_8,currVal_20);
      this._expr_20 = currVal_20;
    }
    valUnwrapper.reset();
    const currVal_22:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform(this.context.message.text)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_14,currVal_22);
      this._expr_22 = currVal_22;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/eva-message/eva-message.component.ngfactory.ts